// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1jOCw","requiredAsterisk":"Info_requiredAsterisk__31K9t"};